import { transformToPeriod } from '@/entities/Period/PeriodTransformers'
import { ShiftIndexUserResource } from '@/entities/User/User'
import { transformToShiftPlanningUser } from '@/entities/User/UserTransformers'

import { ShiftPlanning, ShiftPlanningResource } from './ShiftPlanning'

export const transformToShiftPlanning = (
    resource: ShiftPlanningResource,
    userResource: ShiftIndexUserResource,
): ShiftPlanning => ({
    id: resource.id,
    type: resource.type,
    planned: resource.attributes.planned,
    customStartTime: resource.attributes.customStartTime,
    period: transformToPeriod(
        new Date(resource.attributes.start),
        new Date(resource.attributes.end),
    ),
    user: transformToShiftPlanningUser(userResource),
})
